import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useGetPatients } from '~/backend/connector-api/connector-components';
import { EmptyList } from '../LoadedPatients';
import AvailablePatientData from './AvailablePatientData';

const ServerPatients: React.FC = () => {
    const {
        data: patients,
        error,
        isLoading,
        isFetching,
    } = useGetPatients(
        { queryParams: { series: true } },
        {
            staleTime: 10 * 1000,
        }
    );

    if (isLoading || isFetching) {
        return (
            <Box
                display="flex"
                gap={1}
                alignItems="center"
                justifyContent="center"
                width="100%"
                p={2}
            >
                <Box>
                    <CircularProgress size={12} />
                </Box>
                <Typography variant="body2">
                    <FormattedMessage id="loadingPatients" />
                </Typography>
            </Box>
        );
    }

    if (error) {
        return <div>Error: {error.payload}</div>;
    }

    return patients?.length === 0 ? (
        <EmptyList />
    ) : (
        patients?.map((patient) => (
            <AvailablePatientData patient={patient} key={patient.patientId} />
        ))
    );
};

export default ServerPatients;
